<template>
    <div class="pb-4">
        <div class="px-5">
            <label class="mb-3" style="float: left;">Select Date</label>
            <div>
              
                <!-- :disabled-date="disabledDate" -->
                <a-date-picker @change="onChange" 
                    size="large" 
                    style="width: 100%"/>
            </div>
        </div>
        <div class="px-5 mt-4" v-if="!(this.userInfo && this.userInfo.hub && this.userInfo.hub.id)">
            <label class="mb-3" style="float: left;">Select Hub</label>
            <div>
                <a-select size="large" style="width: 100%"
                    show-search
                    :filter-option="filterOption"
                    placeholder="Select Hub" @change="selectHub">
                    <template v-for="hub in hubs" >
                        <a-select-option :key="hub.id" :value="hub.id">
                            {{hub.name}}
                        </a-select-option>
                    </template>
                </a-select>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import { HUB_LIST } from "../../../script/api";
import { getData } from "../../../script/api-service";

export default {
  data() {
      return {
        hubs: [],
        userInfo: null,
      };
  },
  methods: {
    onChange(date, dateString) {
      this.$parent.selectedDate(dateString)
    },
    disabledDate(current) {
      return current && current < moment().subtract(1, "days").endOf('day');
    },
    async getHubs() {
        let res = await getData(HUB_LIST + '?status=1');

        if (res) {
            let masterData = res.data?.data;
            this.hubs = masterData || [];
        }
    },
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    selectHub(value) {
      console.log(value);
      this.$parent.selecthub(value);
    }
  },
  mounted() {
      this.getHubs();

      let userInfo = localStorage.getItem('logistic-userinfo');
      this.userInfo = JSON.parse(userInfo);
  },
};
</script>